import {
  titleUI,
  currentOrPastDateUI,
  currentOrPastDateSchema,
  textUI,
  phoneUI,
  phoneSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { customTextSchema } from '../../definitions';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['military-service-national-guard-service-title']),
    nationalGuardActivationDate: currentOrPastDateUI({
      title: content['military-service-national-guard-service-activation'],
      monthSelect: false,
    }),
    unitName: textUI({
      title: content['military-service-national-guard-service-unit-name'],
      errorMessages: {
        required:
          content['military-service-national-guard-service-unit-name-error'],
      },
    }),
    unitPhone: phoneUI({
      title: content['military-service-national-guard-service-unit-phone'],
    }),
  },
  schema: {
    type: 'object',
    required: ['nationalGuardActivationDate', 'unitPhone', 'unitName'],
    properties: {
      nationalGuardActivationDate: currentOrPastDateSchema,
      unitName: customTextSchema,
      unitPhone: phoneSchema,
    },
  },
};
